import React from "react";
import { Col, Container, Row } from "reactstrap";
// import nodatafound from "../../../src/assets/images/companyBenchImage/nodatafound.png";
import NodataFound from "../../src/assets/images/nodatafound.svg";

function NodataFoundTable() {
  return (
    <Row>
      <Col
        className="col-12 d-flex justify-content-center align-items-center w-100 m-0 p-0"
        style={{ height: 350 }}
      >
        <div className="text-center ">
          <img
            src={NodataFound}
            style={{ width: "70px" }}
            alt="Dropzone Image"
            className="py-3 d-block mx-auto" // Center the image horizontally
          />
          <h2 className="text-muted font-size-44">No records found</h2>
          <p className="text-center">
            Unfortunately, there is no data available at the moment.
            <br />
            Please check back later or try a different search criteria. Thank
            you.
          </p>
          {/* <Link to={"/dashboard"} className="btn btn-primary">
            Go to dashboard
          </Link> */}
        </div>
      </Col>
    </Row>
  );
}

export default NodataFoundTable;
